export const AVAILABLE_CUSTOM_ROLE_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
  'contact_manage',
  'report_manage',
  'knowledge_base_manage',
];

export const ROLES = ['agent', 'administrator'];

export const MANAGER_PERMISSION = 'manager';

export const CONVERSATION_PERMISSIONS = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const MANAGE_ALL_CONVERSATION_PERMISSIONS = 'conversation_manage';

export const CONVERSATION_UNASSIGNED_PERMISSIONS =
  'conversation_unassigned_manage';

export const CONVERSATION_PARTICIPATING_PERMISSIONS =
  'conversation_participating_manage';

export const CONTACT_PERMISSIONS = 'contact_manage';

export const REPORTS_PERMISSIONS = 'report_manage';

export const PORTAL_PERMISSIONS = 'knowledge_base_manage';

// MakerHub: tab display order is this object's key order (filterItemsByPermission
// iterates Object.entries). Order: All | Urgent | Pending | Group | Mine, with
// All as the default landing tab (see ChatList.vue activeAssigneeTab init) — kept
// first so pinned conversations, which only render on the All view, show on load.
export const ASSIGNEE_TYPE_TAB_PERMISSIONS = {
  all: {
    count: 'allCount',
    // MakerHub: All lists every conversation, but its badge shows only the
    // reply-debt count (badge is decoupled from `count` — count still drives
    // pagination/lazy-load, so it must stay allCount).
    badge: 'needsReplyCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_PARTICIPATING_PERMISSIONS,
    ],
  },
  // MakerHub: Urgent replaces the Unassigned tab (nobody assigns here, so
  // All ≈ Unassigned). One action-required queue CS works to clear.
  urgent: {
    count: 'urgentCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
  // MakerHub: Pending — conversations where WE owe a follow-up (a holding reply
  // with no answer yet). Sits beside Urgent; same action-required audience.
  pending: {
    count: 'pendingCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_UNASSIGNED_PERMISSIONS,
    ],
  },
  // MakerHub: WhatsApp group chats live only here — kept out of All/Urgent/Mine.
  group: {
    count: 'groupCount',
    permissions: [
      ...ROLES,
      MANAGE_ALL_CONVERSATION_PERMISSIONS,
      CONVERSATION_PARTICIPATING_PERMISSIONS,
    ],
  },
  me: {
    count: 'mineCount',
    permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
  },
};
